import request from '@/utils/request'

// 查询种子分页
export function pageSeed(data) {
  return request({
    url: '/cloudplant/seed/page',
    method: 'post',
    data: data
  })
}

// 查询种子列表
export function listSeed(query) {
  return request({
    url: '/cloudplant/seed/list',
    method: 'get',
    params: query
  })
}

// 查询种子详情
export function getSeed(data) {
  return request({
    url: '/cloudplant/seed/detail',
    method: 'get',
    params: data
  })
}

// 新增种子
export function addSeed(data) {
  return request({
    url: '/cloudplant/seed/add',
    method: 'post',
    data: data
  })
}

// 修改种子
export function updateSeed(data) {
  return request({
    url: '/cloudplant/seed/edit',
    method: 'post',
    data: data
  })
}

// 删除种子
export function delSeed(data) {
  return request({
    url: '/cloudplant/seed/delete',
    method: 'post',
    data: data
  })
}
